import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("rs_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function fileUrl(photoId) {
  return `${API_BASE}/photos/${photoId}/file`;
}

/** Photo composited with the event's advert strip when one is uploaded.
 *  Falls back to the raw photo when no strip exists (safe to use everywhere). */
export function brandedUrl(photoId) {
  return `${API_BASE}/photos/${photoId}/branded`;
}

export function downloadUrl(photoId) {
  return `${API_BASE}/photos/${photoId}/download`;
}

export function zipDownloadUrl(slug, bib) {
  return `${API_BASE}/public/events/${slug}/download-zip?bib=${encodeURIComponent(bib)}`;
}

/** Public share URL for an event gallery — routes through backend OG endpoint
 *  so WhatsApp/Facebook/X crawlers see dynamic meta tags before the browser
 *  redirects the human to the SPA. */
export function shareGalleryUrl(slug, bib) {
  const q = bib ? `?bib=${encodeURIComponent(bib)}` : "";
  return `${BACKEND_URL}/api/og/events/${encodeURIComponent(slug)}${q}`;
}

export function sharePhotoUrl(photoId) {
  return `${BACKEND_URL}/api/og/photos/${encodeURIComponent(photoId)}`;
}
